import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import i18n from './i18n'
import VueMeta from 'vue-meta'

import "@/assets/sass/_common.sass"
import alert from '@/components/partials/alert/alert.vue';
Vue.component('alert', alert);
Vue.use(VueMeta)


import Axios from 'axios'
Vue.config.devtools = true;
Vue.config.productionTip = false

const token = localStorage.getItem('jwttoken')
if (token) {
    Axios.defaults.headers.Authorization = "Bearer" + token;
}
Axios.defaults.headers.common = {
    accept: 'application/json',
    'Accept-Language': i18n.locale,
    'content-type': 'application/json'
};


import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
